import Layout from "../../pages/snail/midAutumn/Layout";
import Index from "../../pages/snail/midAutumn/index";
import AnniverSary from "../../pages/snail/midAutumn/anniversary";
import Info from "../../pages/snail/midAutumn/info";
import PC from "../../pages/snail/midAutumn/pc";

const base = "midAutumn";

const routes = [{
  path: `/${base}`,
  component: Layout,
  redirect: `/${base}/anniversary`, // 初始页跳转
  children: [{
    path: `index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `anniversary*`,
    name: `${base}-anniversary`,
    component: AnniverSary
  },
  {
    path: `info*`,
    name: `${base}-info`,
    component: Info
  },
  {
    path: `pc*`,
    name: `${base}-pc`,
    component: PC
  }
  ]
}];

export default routes;


// WEBPACK FOOTER //
// ./src/router/snail/midAutumn.js